import React from 'react';


function Icon(props) {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      style={props?.style}
      className={props?.className}
      xmlns="http://www.w3.org/2000/svg"
     >
      {props?.children}
    </svg>
  );
}

export default Icon;